import React from 'react';
import classNames from 'classnames';
import './index.scss';
;
const FacadeDefault = {
  loading: true,
  conceal: false,
  animated: true,
  avatar: false,
  title: false,
  padding: false,
  marginList: true,
  rows: 5
};

const Facade = ({
  loading,
  conceal,
  animated,
  avatar,
  title,
  padding,
  marginList,
  rows,
  className,
  range: [start = 100, end = 100] = [],
  style,
  avatarStyle,
  titleStyle,
  rowStyle,
  rowListStyle,
  children
}) => {
  const maxStart = Math.max(30, Math.min(start, 100));
  const maxEnd = Math.max(30, Math.min(end, 100));
  const startIsGreater = maxStart > maxEnd;
  const tempRange = Math.abs(maxEnd - maxStart);

  const range = () => {
    const tempResult = tempRange * Math.random();
    return tempResult + (startIsGreater ? maxEnd : maxStart);
  };

  return loading ? /*#__PURE__*/React.createElement("div", {
    className: classNames('facade', {
      conceal,
      animated,
      'no-padding': !padding,
      'no-margin-rowlist': !marginList
    }, className),
    style: style
  }, avatar && /*#__PURE__*/React.createElement("div", {
    className: "facade-profile"
  }, /*#__PURE__*/React.createElement("div", {
    className: "facade-avatar",
    style: avatarStyle
  })), /*#__PURE__*/React.createElement("div", {
    className: "facade-description"
  }, title && /*#__PURE__*/React.createElement("div", {
    className: "facade-title",
    style: titleStyle
  }), !!rows && /*#__PURE__*/React.createElement("ul", {
    style: rowListStyle
  }, Array(rows).fill(null).map((v, index) => /*#__PURE__*/React.createElement("li", {
    key: index,
    style: {
      width: `${rows === index + 1 && rows !== 1 ? maxStart / 2 : range()}%`,
      ...rowStyle
    }
  }))))) : /*#__PURE__*/React.createElement(React.Fragment, null, children);
};

Facade.defaultProps = FacadeDefault;
export default Facade;